import { Position } from "./entities/Position";

export interface MapConfig{
    position: Position,
    mapOptions: google.maps.MapOptions,
    containerStyle: {
        width: string,
        height: string
    }
}

export const DETAIL_ZOOM: number = 18.8722;

const MIN_ZOM: number = 16.23;

const LIMIT_AREA : google.maps.LatLngBoundsLiteral = {
    north: 40.01005176173608,
    south: 39.98375051997416,
    west: -0.0853415576294769,
    east: -0.04791937745369568
};

const START_POSITION = {
    center: {
        lat: 39.994967079027774,
        lng: -0.06900093307439842
    },
    zoom: MIN_ZOM
}

export const initialMapConfig: MapConfig = {
    position: START_POSITION,
    mapOptions : {
        draggable: true,
        fullscreenControl: false,
        scrollwheel: true,
        zoomControl: true,
        clickableIcons: false,
        backgroundColor: 'white',
        mapTypeId: 'satellite',
        disableDefaultUI: true,
        restriction: {
            latLngBounds: LIMIT_AREA,
            strictBounds: false
        },
        minZoom: MIN_ZOM,
        styles: [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            }
        ]
    },
    containerStyle: {
        width: '100vw',
        height: '100vh'
    }
};
